<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	  @import "assets/iconfont/iconfont.css";
	 @import "assets/reset.css";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
a {
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color .2s ease;
}
a:link,
a:visited {
  color: #409EFF;
}
a:hover,
a:active {
  color: #66b1ff;
}
.el-table th {
  background: #eef1f6 !important;
  color: #5e6d82;
}
.el-pagination {
  text-align: center;
  padding: 20px 0;
}
.el-table .disabledRow {
    background: #f4f4f5;
    color: #909399;
}
.el-table {
  border: 1px solid #ebeef5;
}
.stockCard {
	text-align: center;
}
.stockCard span {
	padding: 0 20px 0 0;
}
.stockCard strong {
	color: #F56C6C;
}
.alignCenter {
  text-align: center;
}
.el-radio-group {
  line-height: 40px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue